import React from "react";
import { Helmet } from "react-helmet-async";

const About = () => {
  return (
    <div className="p-[6%] sm:px-[10%] sm:py-[2%]">
      <Helmet>
        <title>{`About Us - Clariss Food Bangladesh`}</title>
        <meta
          name="description"
          content="Clariss Food Bangladesh brings you premium olive oil, sunflower oil, honey, spices, and gourmet essentials. We believe in pure, authentic, and healthy food sourced responsibly for your family."
        />
      </Helmet>

      {/* ✅ Brand Name Heading */}
      <p className="font-bold my-10 text-center">
        <span className="text-accent font-bold text-4xl mr-2">Clariss</span>
        <span className="text-accent font-bold text-black text-4xl">
          Food Bangladesh
        </span>
      </p>

      {/* ✅ Intro Heading */}
      <p className="text-3xl text-secondary font-bold my-10 text-center sm:w-[600px] mx-auto">
        Welcome to Clariss Food Bangladesh – where authentic taste meets healthy living.
      </p>

      <div className="flex flex-col lg:flex-row gap-10 items-center justify-center">
        <div className="w-[100%] lg:w-[50%]">
          <p className="text-3xl text-center font-bold mb-6">
            About Clariss Food Bangladesh
          </p>

          {/* ✅ Brand Story */}
          <p className="font-bold text-[18px]">
            Clariss Food is dedicated to bringing you **pure, premium-quality food products** 
            sourced responsibly from around the world. Our portfolio includes **authentic 
            olive oil, cold-pressed sunflower oil, raw organic honey, exotic spices, and 
            gourmet essentials** crafted for a healthier lifestyle.
          </p>

          <p className="font-bold my-4 text-[18px]">
            <span className="text-accent font-bold mt-2 mb-4">
              Why Choose Clariss Food?
            </span>
            <br />• Sourced from trusted farms & certified producers.  
            <br />• 100% authentic & free from harmful additives.  
            <br />• Preserving natural taste, nutrition & quality.  
          </p>

          <p className="mb-4 font-bold text-[18px]">
            <span className="text-accent font-bold mt-4 mb-2">
              Taste the Difference:
            </span>
            <br />• Extra Virgin Olive Oil rich in antioxidants.  
            <br />• Pure raw honey packed with natural benefits.  
            <br />• Carefully curated spices & gourmet products for every kitchen.  
          </p>

          <p className="font-bold text-[18px]">
            At **Clariss Food Bangladesh**, we believe that eating well is the foundation of 
            living well. Every product reflects our promise of **quality, authenticity, 
            and care for your family’s well-being.**
          </p>

          {/* ✅ License/Origin */}
          <p className="mt-10 font-bold">
            Under License <br />
            Clariss LLC
            <br />
            DWC-LLC, P.O. BOX-712688, Dubai, United Arab Emirates, 712688
            <br />
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
